import microsoftButtonTemplate from "./microsoft-button.html";
import './microsoft-style.scss';

export const microsoftSignInComponent = {
  template: microsoftButtonTemplate,
  controller: Controller
};

/*******************************************************************************
 * Controller
 *******************************************************************************/
/* @ngInject */ function Controller($scope, $injector) {
  var $ctrl = this;
  var $globals = {};
  var $svcs = { $ctrl, $globals, $injector, $scope };

  $injector.invoke(initGlobals, null, $svcs);
  $injector.invoke(initCtrl, null, Object.assign($svcs, { $svcs }));
}

/*******************************************************************************
 * initCtrl */
/**
 * Initializes the Controller object.
 *******************************************************************************/
/* @ngInject */ function initCtrl($ctrl, $injector, $svcs) {
  $ctrl.microsoftLogin = $injector.invoke(microsoftLogin, null, $svcs);
}

/*******************************************************************************
 * initGlobals */
/**
 * Initializes the Globals object.
 *******************************************************************************/
/* @ngInject */ function initGlobals($globals, LoginConstants) {
  const oauth = LoginConstants.oauthConfig;

  Object.assign($globals, {
    oauth,

    /*------------------------------------*/
    /* These options are used as query    */
    /* string parameters for microsoft OAuth */
    /*------------------------------------*/
    oauthOptions: {
      redirect_uri: oauth.redirectURI,
      client_id: oauth.microsoft.clientID,
      access_type: 'offline',
      response_type: 'code',
      prompt: 'select_account',
      scope: oauth.microsoft.consent.join(' '),
      state: oauth.microsoft.name
    }
  });
}

/*******************************************************************************
 * Controller: microsoftLogin */
/**
 * Click handler for the SSO button. Redirects to the Microsoft OAuth page by
 * setting the window location to the Microsoft OAuth URL with the query string.
 *******************************************************************************/
/* @ngInject */ function microsoftLogin($globals) {
  const queryString = new URLSearchParams($globals.oauthOptions);

  return function () {
    window.location.href = `${$globals.oauth.microsoft.rootURL}?${queryString.toString()}`;
  };
}
